:host {
  display: block;
}

::slotted(:not(:first-child)):before {
  content: ' / ';
}
